var Apidae_CartModal = (function() {
    var self = {};
    var closeFn;

    self.closeShowingCart = function() {
        var showingModal = document.querySelector('.modal-cart.show');
        if (!showingModal) return;
        showingModal.classList.remove('show');
        document.body.classList.remove('sidebar-wrap--open');
        document.body.classList.remove('disable-scroll');
        if (closeFn) {
            closeFn();
            closeFn = null;
        }
    };

    self.init = function() {
        document.addEventListener('click', function(e) {
            var target = e.target;
            if (target.dataset && target.dataset.ctaTarget) {
                self.closeShowingCart();
                closeFn = cta(target, document.querySelector(target.dataset.ctaTarget), { relativeToWindow: true }, function showModal(modal) {
                    modal.classList.add('show');
                    document.body.classList.add('sidebar-wrap--open');
                    if (target.dataset.disableScroll) {
                        document.body.classList.add('disable-scroll');
                    }
                });
            } else if (target.classList.contains('exit-sidebar')) {
                self.closeShowingCart();
            } else if (target.classList.contains('modal-close-btn')) {
                self.closeShowingCart();
            }
        });
        document.addEventListener('keyup', function(e) {
            if (e.which === 27) {
                self.closeShowingCart();
            }
        });
    };

    return self;
})();

Apidae_CartModal.init();

var Apidae_Cart = (function() {
    var self = {};
    var cart = $('.cart');
    var dialog = $('.dialog');

    function closePrint() {
        document.body.removeChild(this.__container__);
    }

    function setPrint() {
        this.contentWindow.__container__ = this;
        this.contentWindow.onbeforeunload = closePrint;
        this.contentWindow.onafterprint = closePrint;
        this.contentWindow.focus(); // Required for IE
        this.contentWindow.print();
    }

    self.init = function() {
        $('.grid').on('click', '.button-add-cart', function(e) {
            e.preventDefault();
            var $this = $(this);
            var item = $this.closest('.grid__item');
            var url = item.data('url');

            if (loadData === false) {
                loadData = true;
                var href = url + 'cart/add/';

                $.get(href, function(data) {
                    $('.cart').append(data);
                    $this.removeClass('button-add-cart').addClass('button-add-cart-select');
                    $('.button-cart').addClass('button-cart-select');
                    loadData = false;
                });
            }
        });

        $('.map').on('click', '.button-add-cart', function() {
            $this = $(this);
            item = $this.closest('.grid__item__map');
            var url = item.data('url');

            if (loadData === false) {
                loadData = true;
                var href = url + 'cart/add/';
                $.get(href, function(data) {
                    $('.cart').append(data);
                    $this.removeClass('button-add-cart').addClass('button-add-cart-select');
                    $('.button-cart').removeClass('button-cart-select');
                    loadData = false;
                });
            }
        });

        cart.on('click', '.button-delete-cart', function() {
            $this = $(this);
            item = $this.closest('.cart__block');
            var url = item.data('url');

            if (loadData === false) {
                loadData = true;
                var href = url + 'cart/delete/';
                $.get(href, function(id) {
                    item.remove();
                    $('.grid__item[data-id="' + id + '"]').find('.button-add-cart-select').removeClass('button-add-cart-select').addClass('button-add-cart');
                    $('.grid__item__map[data-id="' + id + '"]').find('.button-add-cart-select').removeClass('button-add-cart-select').addClass('button-add-cart');
                    loadData = false;
                });
            }
        });

        cart.on('click', '.modal-download-button', function() {
            var cartIds = $('.cart__block').map(function() {
                return $(this).data('id');
            }).get();
            var lg = $('#theCart').data("lang");

            window.open(apidae.base_url + '/carts/exportCart/?cartIds=' + cartIds + '&lang=' + lg, '_blank');
        });

        cart.on('click', '.modal-print-button', function() {
            var cartIds = $('.cart__block').map(function() {
                return $(this).data('id');
            }).get();
            var lg = $('#theCart').data("lang");

            var oHiddFrame = document.createElement("iframe");
            oHiddFrame.onload = setPrint;
            oHiddFrame.style.visibility = "hidden";
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.right = "0";
            oHiddFrame.style.bottom = "0";
            oHiddFrame.src = apidae.base_url + '/carts/exportCart/?cartIds=' + cartIds + '&lang=' + lg + '&print=true';
            document.body.appendChild(oHiddFrame);
        });

        dialog.on('click', '#sendMail', function() {
            var cartIds = $('.cart__block').map(function() {
                return $(this).data('id');
            }).get();
            var lg = $('#theCart').data("lang");

            if (loadData === false) {
                loadData = true;
                var url = apidae.base_url + '/carts/sendCart/';

                var dialogForm = $('.dialog-form');
                var name = dialogForm.find("input[name='name']").val();
                var email = dialogForm.find("input[name='email']").val();
                var text = dialogForm.find("input[name='text']").val();

                var data = { cartIds: cartIds, lang: lg, name: name, email: email, text: text };

                $.ajax({
                    type: "POST",
                    url: url,
                    data: data,
                    dataType: 'json'
                }).done(function(data) {
                    if (data.status == 'success') {
                        $(".dialog-form").hide();
                        $(".dialog-alert").prepend(data.message).show();
                    } else if (data.status == 'error') {
                        $(".dialog-form").find('.alert').remove();
                        $(".dialog-form").prepend(data.message);
                    }
                }).always(function() {
                    //Apidae_CartModal.closeShowingCart();
                    loadData = false;
                });
            }

        });
    };

    return self;
})();

$(document).ready(function() {
    Apidae_Cart.init();
});